export default __webpack_public_path__ + "static/media/greekgo-screenshot-05.30321095.png";